import { render } from "./component-wnfw.vue?vue&type=template&id=7b6e6908"
import script from "./component-wnfw.vue?vue&type=script&lang=js"
export * from "./component-wnfw.vue?vue&type=script&lang=js"

import "./component-wnfw.vue?vue&type=style&index=0&id=7b6e6908&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__